module.exports = __webpack_public_path__ + "img/car_shina2_46.9172859c.jpg";